import * as Sentry from '@sentry/react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { DefaultIllustration, TopBar } from '@/components';

import { DefaultContainer } from '@/containers/DefaultContainer';

export const ErrorBoundaryPage = () => {
  const error: any = useRouteError();

  Sentry.captureException(error);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(0);
  };

  return (
    <>
      <TopBar title="" />
      <DefaultContainer>
        <DefaultIllustration
          name="SomethingWentWrong"
          message={error.statusText}
          clickAction={handleClick}
        />
      </DefaultContainer>
    </>
  );
};

export default ErrorBoundaryPage;
